"use client"

import { useMemo } from "react"
import { useVolunteerTableRows } from "../hooks/volunteers.hooks"
import VolunteerCardMobile from "./volunteer-card-mobile"
import VolunteerFilterDialog from "./volunteer-filter-button"
import VolunteerMobileSearchButton from "./volunteer-mobile-search-button"
import Pagination from "@/shared/components/pagination/pagination"
import Loader from "@/shared/components/ui/loader"
import VolunteerDownloadButton from "./volunteer-download-button"
import AddVolunteerButton from "./add-volunteer-button"
import { useSession } from "@/features/auth/context/session.context"
import { UserRole } from "@/shared/constants/user-roles"
import VolunteerFilterIndicator from "./volunteer-filter-indicator"
import VolunteersResultsCount from "./volunteers-results-count"


function VolunteersCardsMobile() {
    const { session } = useSession()
    const canManageVolunteers = session?.role === UserRole.ADMIN || session?.role === UserRole.BASE_LEADER
    const { data, isLoading } = useVolunteerTableRows()
    const total = useMemo(() => {
        if (!data?.success || !data.data) return 0
        return data.data.total
    }, [data])
    const activeTodayCount = useMemo(() => {
        if (!data?.success || !data.data) return 0
        return data.data.activeTodayCount ?? 0
    }, [data])

    return (
        <div className="block lg:hidden space-y-3 mb-10">
            <div className="flex flex-col gap-3">
                {/* Mobile: Filter, search, and buttons on same row */}
                <div className="flex items-center gap-2 w-full">
                    <VolunteerFilterDialog />
                    <div className="flex-1">
                        <VolunteerMobileSearchButton />
                    </div>
                    {canManageVolunteers && (
                        <>
                            <div className="flex-shrink-0">
                                <AddVolunteerButton />
                            </div>
                            <div className="flex-shrink-0">
                                <VolunteerDownloadButton />
                            </div>
                        </>
                    )}
                </div>
                <VolunteersResultsCount
                    total={total}
                    activeTodayCount={activeTodayCount}
                    isLoading={isLoading}
                    compact
                />
            </div>
            <VolunteerFilterIndicator />
            <VolunteerMobileList />
            <Pagination />
        </div>
    )
}

function VolunteerMobileList () {
    const { data, isLoading, isPending } = useVolunteerTableRows()

    if (isLoading) return (
        <div className="py-10 space-y-3 flex justify-center items-center">
            <Loader size={20} />
        </div>
    )

    if (!data?.success) return null

    const users = data.data?.users ?? []

    return (
        <div className="pt-2 space-y-3">
            {users.map((item, index) => (
                <VolunteerCardMobile
                    key={`user-card-mobile-${index}`}
                    item={item}
                />
            ))}
        </div>
    )
}

export default VolunteersCardsMobile